import React from "react";
import { Box, Typography } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import TrainIcon from "@mui/icons-material/Train";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import MovieIcon from "@mui/icons-material/Movie";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import AppsIcon from "@mui/icons-material/Apps";
import StarIcon from "@mui/icons-material/Star";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MapIcon from "@mui/icons-material/Map";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import HomeIcon from "@mui/icons-material/Home";
import BoltIcon from "@mui/icons-material/Bolt";

/**
 * Approximate render of a configured Customer App Service tile in the React
 * Native Home "Top Services" grid: a soft, un-loud image panel with the label
 * and subtitle BELOW it (not overlaid). The admin controls only the panel
 * colour (`service.backgroundColor`); the app owns shape, image treatment,
 * typography and spacing.
 */

// Curated ICON_KEYS (Api/controllers/Admin/appService.controller.js) -> MUI glyph.
const ICON_GLYPH = {
  car: DirectionsCarIcon,
  taxi: LocalTaxiIcon,
  auto: TwoWheelerIcon,
  bike: TwoWheelerIcon,
  bus: DirectionsBusIcon,
  train: TrainIcon,
  ticket: ConfirmationNumberIcon,
  film: MovieIcon,
  wallet: AccountBalanceWalletIcon,
  utensils: RestaurantIcon,
  building: ApartmentIcon,
  bag: ShoppingBagIcon,
  grid: AppsIcon,
  star: StarIcon,
  tag: LocalOfferIcon,
  package: Inventory2Icon,
  card: CreditCardIcon,
  calendar: CalendarMonthIcon,
  map: MapIcon,
  phone: PhoneIphoneIcon,
  home: HomeIcon,
  zap: BoltIcon,
  sports: SportsSoccerIcon,
};

// Matches customer_app HomeScreen.tsx SOFT_CARD_LIGHT.
const SOFT_DEFAULT = "#F2ECEE";
const GLYPH_COLOR = "var(--button_color, #E91E63)";

const ServicePreviewCard = ({ service }) => {
  const displayName = service?.displayName || service?.internalName || "Service";
  const subtitle = service?.subtitle || "";
  const icon = service?.icon || {};
  const Glyph = ICON_GLYPH[icon.iconKey] || AppsIcon;
  const isImage = icon.type === "IMAGE" && icon.imageUrl;
  const cover = isImage && icon.fit !== "CONTAIN";
  const panel = service?.backgroundColor || SOFT_DEFAULT;

  return (
    <Box sx={{ width: 108 }}>
      <Box
        sx={{
          width: 108,
          height: 108,
          borderRadius: "16px",
          bgcolor: panel,
          border: "1px solid rgba(17,17,17,0.05)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          p: cover ? 0 : 1.25,
        }}
      >
        {isImage ? (
          <Box
            component="img"
            src={icon.imageUrl}
            alt=""
            sx={{ width: "100%", height: "100%", objectFit: cover ? "cover" : "contain" }}
          />
        ) : (
          <Glyph sx={{ fontSize: 44, color: GLYPH_COLOR }} />
        )}
      </Box>
      <Typography sx={{ fontWeight: 700, fontSize: 13, textAlign: "center", mt: 1, color: "text.primary" }} noWrap>
        {displayName}
      </Typography>
      {subtitle ? (
        <Typography sx={{ fontSize: 11, color: "text.secondary", textAlign: "center", lineHeight: 1.3 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ServicePreviewCard;
